import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/src/view/styles/variables';
import { CheckIcon } from '../atoms';
const DiagnosisChoiceVariant = {
    icon: 'icon',
    checkbox: 'checkbox',
};
export const DiagnosisChoiceButton = ({ choice, isSelected, onClick, isMultipleChoice }) => {
    const variant = isMultipleChoice
        ? DiagnosisChoiceVariant.checkbox
        : DiagnosisChoiceVariant.icon;
    const isCheckboxVariant = variant === DiagnosisChoiceVariant.checkbox;
    const shouldShowIcon = variant === DiagnosisChoiceVariant.icon && choice.resolvedIconUrl;
    return (React.createElement("div", { className: css(styles.button, isCheckboxVariant && styles.checkboxButton, isSelected && !isCheckboxVariant && styles.selectedButton), onClick: onClick, "data-test": "diagnosisChoiceButton" },
        shouldShowIcon && React.createElement("img", { className: css(styles.icon), src: choice.resolvedIconUrl, alt: choice.label }),
        React.createElement("div", { className: css(styles.label) }, choice.label),
        isCheckboxVariant &&
            (isSelected ? (React.createElement(CheckIcon, { color: Colors.White, classObject: styles.checkboxIcon })) : (React.createElement("div", { className: css(styles.checkbox) })))));
};
const styles = StyleSheet.create({
    button: {
        position: 'relative',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        borderRadius: 14,
        border: `1px solid ${Colors.Gray}`,
        backgroundColor: Colors.White,
        cursor: 'pointer',
        minHeight: 62,
        padding: '16px 24px',
    },
    checkboxButton: {
        justifyContent: 'space-between',
    },
    selectedButton: {
        backgroundColor: Colors.PrimaryLighter,
        borderColor: Colors.PrimaryDark,
        borderWidth: 2,
    },
    icon: {
        width: 40,
        height: 40,
    },
    label: {
        fontSize: 14,
        fontWeight: 'bold',
        color: Colors.Black,
        lineHeight: '100%',
        letterSpacing: 0.56,
    },
    checkbox: {
        width: 24,
        height: 24,
        borderRadius: 4,
        border: `1px solid ${Colors.Gray}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Colors.White,
        flexShrink: 0,
    },
    checkboxIcon: {
        width: 24,
        height: 24,
        borderRadius: 4,
        backgroundColor: Colors.PrimaryDark,
    },
});
